export enum FormSubmissionTimelineItemType {
	CREATED = "created",
	COMMENT = "comment",
	FIELD_VALUES = "field_values",
	IDENTIFIER_VALUE = "identifier_value",
}
